<script lang="ts">
	import { format } from 'svelte-i18n';
	//Design system components
	import { ControlsContainer, Text, LabelList } from '@Shelly/shelly-design-system';
	//Helpers
	import { capFirstChar } from 'src/helpers/utilities';
	//Components
	import VirtualBooleanButton from 'src/components/DevicesSettings/VirtualComponents/Components/VirtualBooleanButton.svelte';
	import ThermostatTemperatureWheel from './ThermostatTemperatureWheel.svelte';
	import ThermostatMode_ST802 from './ThermostatMode_ST802.svelte';
	//Types
	import type { Device } from 'src/types/Device';
	import type { VCInterfaceStatus } from 'src/types/VirtualComponents';

	export let device: Device, statuses: VCInterfaceStatus[];

	let mode: string;
	const _device = device;

	$: enable = statuses.find((i) => /^(enabled?|state)$/.test(i.role));
</script>

<div class="lable-list-wrapper-in-drawer-tab-content mb-s">
	<LabelList
		class="mb-l justify-content-center"
		size="m"
		data-prevent-drawer-swipe
		data-prevent-sidepanel-swipe
		labelList={statuses.filter(
			(i) =>
				new RegExp(
					`^(heater_relay_status|${mode == 'dry' ? 'current_temperature' : 'humidity|current_humidity'})$`,
				).test(i.role) || i?.sensor,
		)}
		on:label-click={(e) => {
			e.stopPropagation();
		}}
	/>
</div>
<div class="flex-full-height justify-content-end">
	{#if enable?.serviceType === 'linkedgo-st-802-hvac'}
		<ThermostatMode_ST802 {device} {statuses} bind:mode />
	{:else}
		<ThermostatTemperatureWheel {device} {statuses} />
	{/if}
	{#if enable != null}
		<ControlsContainer class="mt-s">
			<svelte:fragment slot="first">
				<VirtualBooleanButton
					isWide
					device={_device}
					componentID={enable?.id}
					value={enable?.event}
				/>
				<Text styleType="controls-large" class="mt-s text-bold"
					>{capFirstChar(
						enable?.event
							? $format('label_action_turn_off', { default: 'turn off' })
							: $format('label_action_turn_on', { default: 'turn on' }),
					)}</Text
				>
			</svelte:fragment>
		</ControlsContainer>
	{/if}
</div>
